/* eslint-disable react-hooks/exhaustive-deps */
import { MessageOutlined } from '@ant-design/icons';
import { Button, Form } from 'antd';
import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import i18next from "i18next"

const Style = styled.div`
  position: absolute;
  right: 25px;
  top: 60px;
  background: white;
  padding: 10px 10px 10px 10px;
  box-shadow: 0px 10px 30px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  width: 300px;
  border: 1px solid rgba(0, 0, 0, 0.1);

  .comment-shown {
    display: flex;
    flex-direction: column;

    .link {
      display: flex;
      gap: 8px;
      justify-content: flex-end;
    }
  }
`;

export default function RiskComment({
  comment,
  removeClick = () => { },
  saveClick = () => { },
  id = null,
  isShown,
}) {
  return isShown ? (
    <Style id={id}>
      {comment}
      <div class="comment-shown">
        <div className="link">
          <Button danger size="small" onClick={removeClick}>{i18next.t('Remove')}</Button>
          <Button onClick={saveClick} type="primary" size="small">{i18next.t('Save')}</Button>
        </div>
      </div>
    </Style>
  ) : <div style={{ display: 'none' }}>{comment}</div>;
}


export const RiskGroup = ({
  input,
  inputTypeComponent,
  inputData,
  MainForm,
  options,
  setValues,
  formId,
  inputId,
  inputOnBlur,
  values,
  getInputLabel,
  plainForms,
  setAddress,
  btnOnClick,
  btnOnClick2,
  locationName,
  subGroupTitle,
}) => {
  const [commentIsHidden, setCommentIsHidden] = useState(true);
  const id = useMemo(() => inputData ? `${inputData.name}-${inputData.inputName}` : undefined, [inputData]);

  const hint = useMemo(() => {
    if (inputData) {
      if (i18next.language === 'en') {
        switch (inputData.inputName) {
          case 'threat':
            return `Observations on the threat related to ${subGroupTitle} at ${locationName}`;
          case 'impact':
            return `Observations on the impact of ${subGroupTitle} at ${locationName}`;
          case 'vulnerability':
            return `Observations on the vulnerability to ${subGroupTitle} at ${locationName}`;
          default:
        }
      } else {
        switch (inputData.inputName) {
          case 'threat':
            return 'Observations quant à la menace relative à ce risque';
          case 'impact':
            return 'Observations quant à l’impact de ce risque';
          case 'vulnerability':
            return 'Observations quant à la vulnérabilité des partes prenantes face à ce risque';
          default:
        }
      }
    }
    return '';
  }, [i18next.language]);

  const rules = inputData.rules
    ? inputData.rules.filter(rule => !Object.keys(rule).includes('accept') && !Object.keys(rule).includes('max'))
    : [];

  const requiredRule = rules.find((r) => r.required);

  if (requiredRule && input.inputType === 'text') {
    rules.push({ whitespace: true, message: requiredRule.message || '' });
  }

  return (
    <>
      <RiskComment
        comment={
          <Form.Item
            name={[formId, `${inputData.inputName}Comment`]}
            fieldKey={[formId, `${inputData.inputName}Comment`]}
            initialValue={inputData.commentValue}
            label={i18next.t('Comment')}
            rules={[{ max: 500, message: i18next.t('Comment should not be more than 500 characters') }]}

            hidden={typeof inputData.commentValue !== 'string'}>
            {inputTypeComponent.comment({
              ...inputData,
              commentHint: hint,
            }, {
              form: MainForm,
              forms: options,
              setFormValues: setValues,
              isRisk: true,
            })}
          </Form.Item>
        }
        removeClick={() => {
          const item = document.getElementById(id);
          if (item) {
            const icon = item.querySelector('.anticon-close-circle');
            icon.click();
          }
          btnOnClick();
          setCommentIsHidden((prev) => !prev);
        }}
        id={id}
        isShown={!commentIsHidden}
        saveClick={() => setCommentIsHidden((prev) => !prev)}
      />
      <Form.Item
        required={
          inputData.rules && inputData.rules instanceof Array &&
            inputData.rules.filter(r => r.required).length > 0 ? true : false
        }
        {...(['total100', 'group'].includes(input.inputType) ? {} : {
          name: [formId, inputId],
          fieldKey: [formId, inputId],
          initialValue: inputData.value,
        })}
        {...(['upload', 'imageUpload'].includes(input.inputType) ? {
          valuePropName: "fileList",
          getValueFromEvent: (e) => {
            if (Array.isArray(e)) {
              return e;
            }
            return e && e.fileList && e.fileList.map(f => {
              if (f.response) {
                return f.response;
              }
              return f;
            })
          }
        } : {})}
        {...(inputOnBlur.includes(input.inputType) ? { trigger: "onBlur" } : {})}
        style={input.showOnView === false ? { display: 'none' } : {}}
        {...(['switch'].includes(input.inputType) ? {
          labelCol: { span: 20 },
          style: {
            ...(input.showOnView === false ? { display: 'none' } : {}),
            flexDirection: 'row',
            justifyContent: 'space-between',
          }
        } : {})}
        label={options.dontShowTitle ? null : input.comment ? <span><span>{getInputLabel(input, values)}</span><span>
          <Button
            icon={<MessageOutlined />}
            type="link"
            onClick={() => {
              btnOnClick2();
              setCommentIsHidden((prev) => !prev);
            }}>
            {i18next.t('Comment')}
          </Button>
        </span></span> : getInputLabel(input, values)}
        rules={rules}
        className={input.comment ? `with-comment i-${input.inputType}` : `i-${input.inputType}`}
        data-id={inputData.inputName}>
        {inputTypeComponent[input.inputType]
          ? inputTypeComponent[input.inputType](inputData, {
            form: MainForm,
            forms: options,
            allForms: plainForms,
            setFormValues: setValues,
            setAddress,
            template: 'RISK',
          }) : console.log(input)}
      </Form.Item>
    </>
  )
};
